import React from "react";
import "./CancelBtn.css";

const CancelBtn = ({ CancelBtnClick, closeButon }: any) => {
  return (
    <button
      className="cancel_Button"
      onClick={CancelBtnClick}
      disabled={closeButon}>
      X{/* <img src={refresh}></img> */}
    </button>
  );
};

export default CancelBtn;
// new check
